import { createContext } from "solid-js";
const FormCheckContext = createContext();
export default FormCheckContext;
